// Browse id lists are cached in sessionStorage so in-app navigation keeps the pager working.
// sessionStorage is copied into duplicated tabs, so a cached list is only trusted when it was
// written by the current document; a pasted/opened URL must not resurrect another tab's list.
const listsWrittenByThisDocument = new Set();

export function storeBrowseIds(storageKey, browseIds) {
  listsWrittenByThisDocument.add(storageKey);

  try {
    sessionStorage.setItem(storageKey, JSON.stringify(browseIds));
  } catch (error) {
    // Ignore storage failures (e.g. private mode restrictions) and rely on route state.
  }
}

export function readStoredBrowseIds(storageKey, currentRecordId) {
  if (!listsWrittenByThisDocument.has(storageKey)) {
    return [];
  }

  try {
    const stored = sessionStorage.getItem(storageKey);
    if (!stored) {
      return [];
    }

    const parsed = JSON.parse(stored);
    if (!Array.isArray(parsed)) {
      return [];
    }

    const normalized = parsed.map((id) => Number(id)).filter((id) => Number.isFinite(id));
    if (!Number.isFinite(currentRecordId) || normalized.includes(currentRecordId)) {
      return normalized;
    }

    return [];
  } catch (error) {
    return [];
  }
}
